import NumberInput from "../../components/NumberInput";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { fetchProducts, addProduction } from "../../actions/productAction";
import { fetchProductGroups } from "../../actions/productGroupAction";
import { addCustomer, fetchCustomers } from "../../actions/customerAction";
import { addSale, getSaleById, updateSale } from "../../actions/saleAction";
import { fetchMaterials } from "../../actions/materialAction";
import { closeCashierShift, fetchCurrentCashierShift, openCashierShift } from "../../actions/cashierShiftAction";
import { fetchCities } from "../../actions/regionAction/cityAction";
import { connect } from "react-redux";

import { useNavigate, useSearchParams } from "react-router-dom";
import debounce from "lodash/debounce";
import UserAvatar from "../../components/UserAvatar";
import { formatIDR } from "../../utils/helpers/formatIDR";

import { BASE_URL, BASE_URL_STORAGE } from "../../helpers/config";
import { getActiveOutletId } from "../../utils/helpers/outletContext";
import { cartRecoveryKey } from "./cartRecovery";
import useCartRecovery from "./useCartRecovery";
import CartRecoveryModal from "./components/CartRecoveryModal";
import { toast } from "react-hot-toast";
import Select from "react-select";
import FormProduction from "../ProductPage/FormProduction";
import FormCustomer from "../CustomerPage/FormCustomer";
import QRISModal from "./QRISModal";
import TransferAccountModal from "./TransferAccountModal";
import VariantSelectionModal from "./VariantSelectionModal";
import {
  calculatePosPayment,
  getPosPaymentPreviewAmount,
  getRecordedSalePayment,
  isAutomaticPaymentMethod,
  normalizeCurrencyInput,
} from "./paymentCalculations";
import TablerIcon from "./components/TablerIcon";
import CartFlyAnimation from "./components/CartFlyAnimation";
import AnimatedCurrency from "./components/AnimatedCurrency";
import TransactionSuccessFeedback from "./components/TransactionSuccessFeedback";
import CartItemNoteModal from "./components/CartItemNoteModal";
import ProductListView from "./components/ProductListView";
import useMobileCartDrag from "./useMobileCartDrag";
import VariantAvailabilityDrawer from "./components/VariantAvailabilityDrawer";
import { AlertConfirmModal } from "../../components/Modals/AlertConfirmModal";
import { fetchPosPaymentAccount } from "../../actions/cashBankAction";
import { canEditSale, canProcessSale, hasAllPermissions } from "../../utils/helpers/permissions";
import {
  ALL_PRODUCT_CATEGORIES,
  filterSellerCatalog,
  buildProductCategoryOptions,
  buildVisibleProducts,
  buildVisibleProductGroups,
  getProductStockLimit,
  getProductRemainingStock,
  getCatalogAvailabilityTarget,
  canOpenCatalogProduct,
} from "./productCatalog";
import "./pos.css";
import PATH_URL from "../../routers/path";

const isCashierShiftEnabled = process.env.REACT_APP_ENABLE_CASHIER_SHIFT === "true";

const getProductCategoryName = (product = {}) => product?.category_label || product?.category;
const PAYMENT_METHOD_LABELS = {
  cash: "Tunai",
  qris: "QRIS",
  transfer: "Transfer",
};

const POS_INITIAL_STATE = {
  customer_id: 1,
  payment_method: "cash",
  total: 0,
  pay: 0,
  due: 0,
  tax: 0,
  discount: 0,
  note: "",
  details: [],
};

const ProductGridSkeleton = () => (
  <>
    {[...Array(6)].map((_, index) => (
      <div key={`product-grid-skeleton-${index}`} className="col">
        <div className="card card-sm h-100 border-1 overflow-hidden">
          <div className="placeholder-glow">
            <div className="placeholder w-100 rounded-top pos-product-image-skeleton"></div>
          </div>
          <div className="p-3 placeholder-glow">
            <div className="placeholder placeholder-lg col-10 mb-2"></div>
            <div className="placeholder placeholder-sm col-6 mb-4"></div>
            <div className="d-flex justify-content-between align-items-center">
              <div className="placeholder placeholder-lg col-5"></div>
              <div className="placeholder placeholder-lg col-3 d-none d-lg-block"></div>
            </div>
          </div>
        </div>
      </div>
    ))}
  </>
);

const PosPage = (props) => {
  const {
    products,
    isLoading,
    productLoading,
    fetchProducts,
    addSale,
    getSaleById,
    updateSale,
    fetchCustomers,
    addCustomer,
    fetchCities,
    customers,
    cities,
    addProduction,
    storeSetting,
    currentCashierShift,
    fetchCurrentCashierShift,
    openCashierShift,
    closeCashierShift,
    userProfile,
    productGroups,
    productGroupLoading,
    fetchProductGroups,
    fetchPosPaymentAccount,
  } = props;
  const canCreateProductions = hasAllPermissions(userProfile, ["create-productions", "process-productions"]);
  const catalogLoading = productLoading || productGroupLoading;
  const navigate = useNavigate();

  const [perPage, _setPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [viewMode, setViewMode] = useState("grid");
  const [selectedProductCategory, setSelectedProductCategory] = useState(ALL_PRODUCT_CATEGORIES);
  const [selectedProductGroup, setSelectedProductGroup] = useState(null);
  const [unavailableCatalogProduct, setUnavailableCatalogProduct] = useState(null);
  const [isDiscount, setIsDiscount] = useState(false);
  const [isNoteEnabled, setIsNoteEnabled] = useState(false);
  const [isSubmittingSale, setIsSubmittingSale] = useState(false);
  const [openingCash, setOpeningCash] = useState(0);
  const [openingNote, setOpeningNote] = useState("");
  const [closingCash, setClosingCash] = useState(0);
  const [closingNote, setClosingNote] = useState("");
  const [transferPaymentAccount, setTransferPaymentAccount] = useState(null);
  const [isTransferAccountLoading, setIsTransferAccountLoading] = useState(true);
  const paymentAmountEditedRef = useRef(false);
  const currentShiftSummary = currentCashierShift?.summary || {};
  const hasOpenShift =
    !isCashierShiftEnabled || Boolean(currentCashierShift?.id && currentCashierShift?.status === "open");
  const expectedClosingCash = Number(currentShiftSummary?.expected_cash || 0);
  const closingDifference = Number(closingCash || 0) - expectedClosingCash;

  const decreaseQuantity = (product_id) => {
    setFormState((prev) => {
      const details = (prev?.details || [])
        .map((item) => {
          if (item?.product_id !== product_id) {
            return item;
          }
          // if (item?.qty === 1) {
          //   // hapus item index ini
          //   return null;
          // }
          const qty = Number(item?.qty || 0) - 1;

          return {
            ...item,
            qty,
            subtotal: qty * Number(item?.unit_price || 0),
          };
        })
        ?.filter((item) => item?.qty > 0);

      const payment = calculatePosPayment({ ...prev, details }, isDiscount);

      return {
        ...prev,
        details,
        ...payment,
      };
    });
  };

  const increaseQuantity = (product_id) => {
    const cartItem = formState?.details?.find((item) => item?.product_id === product_id);
    const product = products?.find((candidate) => candidate?.id === product_id);
    const availableStock = cartItem?.stock_unlimited
      ? Number.POSITIVE_INFINITY
      : Number(cartItem?.stock_available ?? getProductStockLimit(product));

    if (!cartItem) {
      return;
    }

    if (!cartItem?.stock_unlimited && Number(cartItem?.qty || 0) >= availableStock) {
      toast.error(`Jumlah ${cartItem?.product_name || "produk"} sudah mencapai stok tersedia.`);
      return;
    }

    setFormState((prev) => {
      const details = (prev?.details || []).map((item) => {
        if (item?.product_id !== product_id) {
          return item;
        }

        const qty = Number(item?.qty || 0) + 1;
        return {
          ...item,
          qty,
          subtotal: qty * Number(item?.unit_price || 0),
        };
      });
      const payment = calculatePosPayment({ ...prev, details }, isDiscount);

      return {
        ...prev,
        details,
        ...payment,
      };
    });
  };

  const productionInitialState = {
    name: "",
    type: "",
    category: "",
    weight: "",
    unit: "pcs",
    unit_price: 0,
    stock: 0,
    min_stock: 0,
    image: "",
    description: "",
    qty_production: 1,
    materials: [],
  };
  const [formState, setFormState] = useState(POS_INITIAL_STATE);
  const hasGroupedCatalog = productGroups.length > 0;
  const posCatalog = useMemo(() => filterSellerCatalog(hasGroupedCatalog ? productGroups : products), [hasGroupedCatalog, productGroups, products]);
  const productCategoryOptions = useMemo(
    () => buildProductCategoryOptions(posCatalog),
    [posCatalog],
  );
  const visibleProducts = useMemo(
    () =>
      hasGroupedCatalog
        ? buildVisibleProductGroups(posCatalog, formState?.details || [], selectedProductCategory)
        : buildVisibleProducts(posCatalog, formState?.details || [], selectedProductCategory),
    [formState?.details, hasGroupedCatalog, posCatalog, selectedProductCategory],
  );
  const customerInitialState = {
    id: "",
    name: "",
    phone: "",
    image: null,
    image_url: "",
    image_path: "",
    category: "personal",
    city_id: "",
    city_name: "",
    is_member: 0,
    is_reseller: 0,
    is_display_landing: 0,
    points: 0,
  };
  const [customerFormState, setCustomerFormState] = useState(customerInitialState);
  const [productionState, setProductionState] = useState(productionInitialState);
  const [isMobileCartExpanded, setIsMobileCartExpanded] = useState(false);
  const [cartFlights, setCartFlights] = useState([]);
  const [isCartReceivingItem, setIsCartReceivingItem] = useState(false);
  const [transactionFeedback, setTransactionFeedback] = useState(null);
  const [selectedCartItem, setSelectedCartItem] = useState(null);
  const checkoutAttemptRef = useRef({ fingerprint: "", key: "" });
  const editSubmittingRef = useRef(false);
  const cartTargetRef = useRef(null);
  const cartFlightSequenceRef = useRef(0);
  const cartPulseFrameRef = useRef(null);
  const cartPulseTimeoutRef = useRef(null);
  const hasCartItems = formState?.details?.length > 0;
  const mobileCartDrag = useMobileCartDrag({
    expanded: isMobileCartExpanded,
    hasItems: hasCartItems,
    onExpandedChange: setIsMobileCartExpanded,
  });
  const discountExceedsSubtotal = Number(formState?.discount || 0) > Number(formState?.subtotal || 0);
  const cartHealthAlerts = useMemo(() => {
    const details = formState?.details || [];
    const stockAlerts = details
      .filter((item) => !item?.stock_unlimited && Number(item?.qty || 0) > Number(item?.stock_available || 0))
      .map((item) => `${item.product_name} melebihi stok tersedia`);
    const missingCogsAlerts = details
      .filter((item) => Number(item?.unit_cogs || 0) <= 0)
      .map((item) => `${item.product_name} belum punya HPP`);
    const thinMarginAlerts = details
      .filter((item) => {
        const unitPrice = Number(item?.unit_price || 0);
        const unitCogs = Number(item?.unit_cogs || 0);
        const margin = unitPrice > 0 ? ((unitPrice - unitCogs) / unitPrice) * 100 : 0;

        return unitCogs > 0 && margin < 25;
      })
      .map((item) => `${item.product_name} margin tipis`);

    return [
      ...stockAlerts.map((message) => ({ type: "danger", message })),
      ...missingCogsAlerts.map((message) => ({ type: "warning", message })),
      ...thinMarginAlerts.map((message) => ({ type: "warning", message })),
    ].slice(0, 3);
  }, [formState?.details]);
  const hasBlockingCartAlert = cartHealthAlerts.some((alert) => alert.type === "danger");

  const triggerCartArrivalPulse = () => {
    if (cartPulseFrameRef.current) {
      window.cancelAnimationFrame(cartPulseFrameRef.current);
    }
    if (cartPulseTimeoutRef.current) {
      window.clearTimeout(cartPulseTimeoutRef.current);
    }

    setIsCartReceivingItem(false);
    cartPulseFrameRef.current = window.requestAnimationFrame(() => {
      setIsCartReceivingItem(true);
      cartPulseTimeoutRef.current = window.setTimeout(() => {
        setIsCartReceivingItem(false);
      }, 420);
    });
  };

  const getProductFlightImage = (product) => {
    const imagePath = product?.image_path || product?.image_url || product?.image;
    if (!imagePath) return "";
    if (/^(https?:|data:|blob:)/i.test(imagePath)) return imagePath;

    return BASE_URL_STORAGE + imagePath;
  };

  const launchProductFlight = (product, sourceElement) => {
    const prefersReducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    const targetElement = cartTargetRef.current;

    if (!sourceElement || !targetElement || prefersReducedMotion) {
      triggerCartArrivalPulse();
      return;
    }

    const sourceRect = sourceElement.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const size = viewportWidth <= 575.98 ? 44 : 52;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const startX = clamp(sourceRect.left + sourceRect.width / 2 - size / 2, 8, viewportWidth - size - 8);
    const startY = clamp(sourceRect.top + sourceRect.height / 2 - size / 2, 8, viewportHeight - size - 8);
    const endX = clamp(targetRect.left + targetRect.width / 2 - size / 2, 8, viewportWidth - size - 8);
    const endY = clamp(targetRect.top + targetRect.height / 2 - size / 2, 8, viewportHeight - size - 12);
    const curveLift = Math.min(128, Math.max(52, Math.abs(endY - startY) * 0.2));
    const id = ++cartFlightSequenceRef.current;

    setCartFlights((currentFlights) => [
      ...currentFlights,
      {
        id,
        size,
        startX,
        startY,
        midX: startX + (endX - startX) * 0.56,
        midY: Math.min(startY, endY) - curveLift,
        endX,
        endY,
        imageUrl: getProductFlightImage(product),
      },
    ]);
  };

  const finishProductFlight = (flightId) => {
    setCartFlights((currentFlights) => currentFlights.filter((flight) => flight.id !== flightId));
    triggerCartArrivalPulse();
  };

  useEffect(
    () => () => {
      if (cartPulseFrameRef.current) {
        window.cancelAnimationFrame(cartPulseFrameRef.current);
      }
      if (cartPulseTimeoutRef.current) {
        window.clearTimeout(cartPulseTimeoutRef.current);
      }
    },
    [],
  );

  const showMobileCartPeek = () => {
    setIsMobileCartExpanded(false);
  };

  const closeMobileCart = () => {
    setIsMobileCartExpanded(false);
  };

  const toggleMobileCart = () => {
    if (!hasCartItems && !isMobileCartExpanded) {
      return;
    }

    setIsMobileCartExpanded((isExpanded) => !isExpanded);
  };

  const addProductToCart = (product, sourceElement) => {
    const remainingStock = getProductRemainingStock(product, formState?.details || []);
    if (remainingStock <= 0) {
      toast.error(
        product?.inventory_mode === "made_to_order"
          ? "Bahan baku belum mencukupi untuk membuat produk ini."
          : "Stok habis! Lakukan produksi kembali.",
      );
      return;
    }

    launchProductFlight(product, sourceElement);
    setFormState((previous) => {
      const existing = previous.details.find((item) => item.product_id === product.id);
      if (existing) {
        return {
          ...previous,
          details: previous.details.map((item) =>
            item.product_id === product.id
              ? {
                  ...item,
                  qty: Number(item.qty) + 1,
                  subtotal: (Number(item.qty) + 1) * Number(item.unit_price),
                }
              : item,
          ),
        };
      }

      return {
        ...previous,
        details: [
          ...previous.details,
          {
            product_id: product.id,
            product_name:
              product?.product_group_name && product?.variant_label
                ? `${product.product_group_name} - ${product.variant_label}`
                : product.name,
            product_group_name: product?.product_group_name,
            variant_label: product?.variant_label,
            qty: 1,
            unit: product.unit,
            unit_price: product.unit_price,
            unit_cogs: product.unit_cogs,
            weight: product.weight,
            subtotal: product.unit_price,
            stock_available: Number.isFinite(getProductStockLimit(product)) ? getProductStockLimit(product) : null,
            stock_unlimited: Boolean(product?.is_unlimited || product?.inventory_mode === "non_stock"),
            inventory_mode: product?.inventory_mode,
            image: product.image,
            image_path: product.image_path || product.image,
            image_url: product.image_path || product.image,
            note: "",
          },
        ],
      };
    });
    showMobileCartPeek();
  };

  const selectCatalogProduct = (catalogItem, sourceElement) => {
    if (!catalogItem?.is_product_group) {
      const availabilityTarget = getCatalogAvailabilityTarget(catalogItem);
      if (availabilityTarget) {
        setUnavailableCatalogProduct(availabilityTarget);
        return;
      }

      addProductToCart(catalogItem, sourceElement);
      return;
    }

    const availableVariants = (catalogItem?.variants || []).filter(
      (variant) => variant?.can_sell !== false && variant?.remaining_stock > 0,
    );
    if (catalogItem?.variants?.length > 1) {
      setSelectedProductGroup(catalogItem);
      return;
    }
    if (availableVariants.length === 0) {
      const availabilityTarget = getCatalogAvailabilityTarget(catalogItem);
      if (availabilityTarget) {
        setUnavailableCatalogProduct(availabilityTarget);
        return;
      }

      toast.error("Varian produk sedang tidak tersedia.");
      return;
    }
    addProductToCart(availableVariants[0], sourceElement);
  };

  const handleSelectVariant = (variant, sourceElement) => {
    addProductToCart(variant, sourceElement);
    setSelectedProductGroup(null);
  };

  const [isShowModal, setIsShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchFromUrl = searchParams.get("search") || "";
  const editSaleId = Number(searchParams.get("edit_sale") || 0) || null;
  const isEditingSale = Boolean(editSaleId);
  const editSaleLoadedRef = useRef(null);
  const [editingSale, setEditingSale] = useState(null);
  const [editSaleLoading, setEditSaleLoading] = useState(false);
  const recordedPayment = isEditingSale ? getRecordedSalePayment(editingSale) : 0;
  const isPaymentEnough = recordedPayment + Number(formState?.pay || 0) >= Number(formState?.total || 0);
  const canPayEditedSale = isEditingSale && Boolean(editingSale?.edit_version) && canProcessSale(userProfile, editingSale);
  const remainingBeforePayment = Math.max(0, Number(formState.total || 0) - recordedPayment);
  const paymentPreviewAmount = getPosPaymentPreviewAmount(formState);
  const editedTotalBelowPaid = isEditingSale && Number(formState?.total || 0) < recordedPayment;
  const editPaymentError = isEditingSale && isAutomaticPaymentMethod(formState.payment_method)
    && paymentPreviewAmount > remainingBeforePayment;
  const recovery = useCartRecovery({
    storageKey: cartRecoveryKey({
      origin: window.location.origin,
      api: BASE_URL,
      tenant: userProfile?.tenant_id || window.location.hostname,
      outlet: getActiveOutletId() || userProfile?.current_outlet_id,
      user: userProfile?.id,
    }),
    enabled: !isEditingSale,
    formState,
    isDiscount,
    onReset: () => {
      setFormState(POS_INITIAL_STATE);
      setIsDiscount(false);
      setIsNoteEnabled(false);
    },
    onRestore: (saved, result) => {
      // Jangan pulihkan nominal bayar atau status pembayaran dari penyimpanan browser.
      paymentAmountEditedRef.current = true;
      setIsDiscount(saved.discount > 0);
      setIsNoteEnabled(Boolean(saved.note));
      setFormState({
        ...POS_INITIAL_STATE,
        customer_id: result.customerId,
        details: result.details,
        discount: saved.discount,
        tax: saved.tax,
        note: saved.note,
        payment_method: saved.payment_method,
        ...calculatePosPayment({ ...saved, details: result.details, pay: 0 }, saved.discount > 0),
      });
      setIsMobileCartExpanded(false);
    },
  });

  const [filterText, setFilterText] = useState(searchFromUrl);
  const closeModal = () => {
    setProductionState(productionInitialState);
    setIsShowModal(false);
    setIsEdit(false);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilterText(value);
    const nextParams = new URLSearchParams(searchParams);
    if (value) nextParams.set("search", value);
    else nextParams.delete("search");
    setSearchParams(nextParams);
  };

  useEffect(() => {
    fetchCustomers(10000, 1, "", "");
  }, [fetchCustomers]);

  useEffect(() => {
    fetchCities(10000, 1, "");
  }, [fetchCities]);

  useEffect(() => {
    let active = true;
    setIsTransferAccountLoading(true);
    fetchPosPaymentAccount("transfer").then((result) => {
      if (!active) return;
      setTransferPaymentAccount(result);
      setIsTransferAccountLoading(false);
    });

    return () => {
      active = false;
    };
  }, [fetchPosPaymentAccount]);

  useEffect(() => {
    if (!isCashierShiftEnabled) {
      return;
    }

    fetchCurrentCashierShift();
  }, [fetchCurrentCashierShift]);

  useEffect(() => {
    if (isCashierShiftEnabled && hasOpenShift) {
      setClosingCash(Number(currentShiftSummary?.expected_cash || 0));
    }
  }, [currentShiftSummary?.expected_cash, hasOpenShift]);

  useEffect(() => {
    setFilterText(searchFromUrl);
  }, [searchFromUrl]);

  useEffect(() => {
    if (!editSaleId || editSaleLoadedRef.current === editSaleId || products.length === 0) return;
    let active = true;
    setEditSaleLoading(true);
    getSaleById(editSaleId, { silent: true }).then((result) => {
      if (!active) return;
      const sale = result?.data;
      if (
        !result?.success ||
        !sale ||
        !["draft", "unpaid"].includes(sale.payment_status) ||
        sale.has_managed_bills ||
        !canEditSale(userProfile, sale)
      ) {
        toast.error(
          sale?.has_managed_bills
            ? "Kembalikan split/merge tagihan sebelum mengubah transaksi."
            : "Transaksi ini tidak dapat diubah.",
        );
        navigate(PATH_URL.SALE, { replace: true });
        setEditSaleLoading(false);
        return;
      }

      const restoredDetails = (sale.details || []).map((detail) => {
        const product = products.find((item) => Number(item.id) === Number(detail.product_id)) || detail;
        const stockLimit = getProductStockLimit(product);
        const restoredLimit = Number.isFinite(stockLimit)
          ? stockLimit + (sale.payment_status === "unpaid" ? Number(detail.qty || 0) : 0)
          : null;
        return {
          ...product,
          ...detail,
          product_name: detail.product_name || product.name,
          subtotal: Number(detail.qty || 0) * Number(detail.unit_price ?? product.unit_price ?? 0),
          unit_price: Number(detail.unit_price ?? product.unit_price ?? 0),
          stock_available: restoredLimit,
          stock_unlimited: !Number.isFinite(stockLimit),
          image_path: detail.image || product.image_path || product.image,
          image_url: detail.image || product.image_path || product.image,
        };
      });
      paymentAmountEditedRef.current = !canProcessSale(userProfile, sale);
      setEditingSale(sale);
      setIsDiscount(Number(sale.discount || 0) > 0);
      setIsNoteEnabled(Boolean(sale.note));
      setFormState({
        ...POS_INITIAL_STATE,
        ...sale,
        customer_id: sale.customer_id || 1,
        payment_method: ["cash", "qris", "transfer"].includes(sale.payment_method) ? sale.payment_method : "cash",
        pay: 0,
        discount: Number(sale.discount || 0),
        tax: Number(sale.tax || 0),
        details: restoredDetails,
      });
      editSaleLoadedRef.current = editSaleId;
      setEditSaleLoading(false);
    });
    return () => {
      active = false;
    };
  }, [editSaleId, getSaleById, navigate, products, userProfile]);

  useEffect(() => {
    if (
      selectedProductCategory !== ALL_PRODUCT_CATEGORIES &&
      !productCategoryOptions.some((category) => category.value === selectedProductCategory)
    ) {
      setSelectedProductCategory(ALL_PRODUCT_CATEGORIES);
    }
  }, [productCategoryOptions, selectedProductCategory]);

  const debouncedFetch = useMemo(
    () =>
      debounce((page, limit, search) => {
        fetchProducts(limit, page, search);
        fetchProductGroups(limit, page, search);
      }, 500),
    [fetchProductGroups, fetchProducts],
  );
  useEffect(() => {
    debouncedFetch(currentPage, perPage, searchFromUrl);

    return () => {
      debouncedFetch.cancel();
    };
  }, [currentPage, perPage, searchFromUrl, debouncedFetch]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchFromUrl]);
  useEffect(() => {
    setFormState((prev) => {
      const payment = calculatePosPayment(prev, isDiscount, {
        autoFillPayment: isAutomaticPaymentMethod(prev.payment_method) && !paymentAmountEditedRef.current,
        paidAmount: recordedPayment,
      });

      if (
        prev.subtotal === payment.subtotal &&
        prev.total === payment.total &&
        prev.pay === payment.pay &&
        prev.due === payment.due &&
        prev.change === payment.change
      ) {
        return prev;
      }

      return {
        ...prev,
        ...payment,
      };
    });
  }, [formState.details, formState.pay, formState.discount, formState.tax, formState.payment_method, isDiscount, recordedPayment]);

  const handlePaymentMethodChange = (event) => {
    const paymentMethod = event.target.value;
    paymentAmountEditedRef.current = false;

    setFormState((previous) => {
      const nextState = { ...previous, payment_method: paymentMethod };
      return {
        ...nextState,
        ...calculatePosPayment(nextState, isDiscount, {
          autoFillPayment: isAutomaticPaymentMethod(paymentMethod),
          paidAmount: recordedPayment,
        }),
      };
    });
  };

  const createIdempotencyKey = () => {
    if (window.crypto?.randomUUID) {
      return window.crypto.randomUUID();
    }

    return `pos-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  };

  const getCheckoutIdempotencyKey = (state, paymentStatus) => {
    const fingerprint = JSON.stringify({
      customer_id: state?.customer_id || null,
      payment_method: state?.payment_method,
      discount: Number(state?.discount || 0),
      tax: Number(state?.tax || 0),
      total: Number(state?.total || 0),
      payment_status: paymentStatus || "checkout",
      ...(paymentStatus === "edit-payment" ? {
        pay: Number(state?.pay || 0),
        note: state?.note || "",
        edit_sale_id: editSaleId,
        edit_version: editingSale?.edit_version,
      } : {}),
      details: (state?.details || []).map((item) => ({
        product_id: item.product_id,
        qty: Number(item.qty || 0),
        note: String(item?.note || "").trim(),
      })),
    });

    if (checkoutAttemptRef.current.fingerprint !== fingerprint) {
      checkoutAttemptRef.current = { fingerprint, key: createIdempotencyKey() };
    }

    return checkoutAttemptRef.current.key;
  };

  const resetCart = () => {
    recovery.clear();
    paymentAmountEditedRef.current = false;
    setFormState(POS_INITIAL_STATE);
    setSelectedCartItem(null);
    setIsDiscount(false);
    setIsNoteEnabled(false);
    checkoutAttemptRef.current = { fingerprint: "", key: "" };
    closeMobileCart();
  };

  const saveCartItemNote = (productId, note) => {
    setFormState((previous) => ({
      ...previous,
      details: previous.details.map((item) =>
        String(item.product_id) === String(productId) ? { ...item, note } : item,
      ),
    }));
    setSelectedCartItem((current) => (current ? { ...current, note } : current));
  };

  const openCustomerModal = () => {
    closeMobileCart();
    setCustomerFormState(customerInitialState);
  };

  const closeCustomerModal = () => {
    setCustomerFormState(customerInitialState);
  };

  const handleAddCustomer = async () => {
    const result = await addCustomer(customerFormState);
    if (!result) return false;
    await fetchCustomers(10000, 1, "", "");

    // Auto-select customer yang baru dibuat
    if (result && typeof result === "object" && result.id) {
      setFormState((prev) => ({
        ...prev,
        customer_id: result.id,
        customer_name: result.name || "",
        customer_phone: result.phone || "",
      }));
    }

    document.querySelector("#modal-pos-customer .btn-close")?.click();
    closeCustomerModal();
    return true;
  };

  const setPaymentAmount = (amount) => {
    setFormState((prev) => {
      const total = Number(prev?.total || 0);
      const pay = Number(amount || 0);

      return {
        ...prev,
        pay,
        due: Math.max(0, total - pay),
        change: pay > total ? pay - total : 0,
      };
    });
  };

  const handlePay = async () => {
    if (!isPaymentEnough) {
      return;
    }

    await submitSale();
  };

  const submitSale = async () => {
    if (recovery.snapshot) return;
    if (isCashierShiftEnabled && !hasOpenShift) {
      toast.error("Shift kasir belum dibuka. Buka shift terlebih dahulu.");
      return;
    }

    if (hasBlockingCartAlert) {
      toast.error("Ada item yang melebihi stok tersedia. Cek keranjang dulu ya.");
      return;
    }

    if (discountExceedsSubtotal) {
      toast.error("Diskon tidak boleh melebihi subtotal transaksi.");
      return;
    }

    if (isSubmittingSale || formState?.details.length === 0) {
      return;
    }

    const transactionSnapshot = {
      id: Date.now(),
      title: isPaymentEnough ? "Pembayaran berhasil" : "Transaksi tersimpan",
      total: Number(formState?.total || 0),
      paymentLabel: PAYMENT_METHOD_LABELS[formState?.payment_method] || "Pembayaran",
    };

    setIsSubmittingSale(true);
    recovery.markSubmitting();
    const result = await addSale({
      ...formState,
      payment_status: undefined,
      idempotency_key: getCheckoutIdempotencyKey(formState),
    });
    recovery.finishSubmission(result);

    if (result?.success) {
      setTransactionFeedback(transactionSnapshot);
      resetCart();
    } else {
      fetchProducts(perPage, currentPage, searchFromUrl);
      fetchProductGroups(perPage, currentPage, searchFromUrl);
    }

    setIsSubmittingSale(false);
  };

  const handleConfirmUnpaidSale = async () => {
    await submitSale();
  };

  const handleUpdateSale = async (withPayment = false) => {
    if (
      !editingSale ||
      editSubmittingRef.current ||
      isSubmittingSale ||
      formState?.details.length === 0 ||
      hasBlockingCartAlert ||
      discountExceedsSubtotal ||
      editedTotalBelowPaid
    ) {
      if (hasBlockingCartAlert) toast.error("Ada item yang melebihi stok tersedia.");
      if (discountExceedsSubtotal) toast.error("Diskon tidak boleh melebihi subtotal transaksi.");
      if (editedTotalBelowPaid) toast.error("Total baru tidak boleh lebih kecil dari pembayaran yang sudah diterima.");
      return;
    }
    if (withPayment && (!canPayEditedSale || !Number.isInteger(paymentPreviewAmount) || paymentPreviewAmount <= 0
      || remainingBeforePayment <= 0 || editPaymentError)) {
      toast.error(!canPayEditedSale ? "Anda tidak memiliki izin memproses pembayaran." :
        editPaymentError ? "Pembayaran QRIS/Transfer tidak boleh melebihi sisa tagihan." : "Masukkan pembayaran tambahan dalam rupiah bulat, minimal Rp1.");
      return;
    }
    editSubmittingRef.current = true;
    setIsSubmittingSale(true);
    try {
      const result = await updateSale(editingSale.id, {
        sale_date: editingSale.sale_date,
        edit_version: editingSale.edit_version,
        customer_id: formState.customer_id || null,
        discount: Number(formState.discount || 0),
        tax: Number(formState.tax || 0),
        note: formState.note || "",
        details: formState.details.map((item) => ({
          product_id: item.product_id,
          qty: Number(item.qty || 0),
          note: String(item.note || "").trim(),
        })),
        ...(withPayment ? {
          payment_amount: paymentPreviewAmount,
          payment_method: formState.payment_method,
          idempotency_key: getCheckoutIdempotencyKey(formState, "edit-payment"),
        } : {}),
      });
      if (result?.success) {
        navigate(PATH_URL.SALE, { replace: true });
      }
    } finally {
      editSubmittingRef.current = false;
      setIsSubmittingSale(false);
    }
  };

  const handleSaveDraft = async () => {
    if (recovery.snapshot) return;
    if (isSubmittingSale || formState?.details.length === 0) {
      return;
    }
    if (discountExceedsSubtotal) {
      toast.error("Diskon tidak boleh melebihi subtotal transaksi.");
      return;
    }

    setIsSubmittingSale(true);
    recovery.markSubmitting();
    const result = await addSale(
      { ...formState, payment_status: "draft", idempotency_key: getCheckoutIdempotencyKey(formState, "draft") },
      { print: false },
    );
    recovery.finishSubmission(result);

    if (result?.success) {
      toast.success("Transaksi berhasil disimpan ke draft! 📋");
      resetCart();
    }

    setIsSubmittingSale(false);
  };

  const handleOpenShift = async () => {
    const result = await openCashierShift({
      opening_cash: Number(openingCash || 0),
      opening_note: openingNote,
    });

    if (result?.success) {
      setOpeningCash(0);
      setOpeningNote("");
    }
  };

  const handleCloseShift = async () => {
    if (!currentCashierShift?.id) {
      return;
    }

    const result = await closeCashierShift(currentCashierShift.id, {
      closing_cash: Number(closingCash || 0),
      closing_note: closingNote,
    });

    if (result?.success) {
      setClosingCash(0);
      setClosingNote("");
      fetchProducts(perPage, currentPage, searchFromUrl);
      fetchProductGroups(perPage, currentPage, searchFromUrl);
    }
  };

  const optionCustomers = customers?.map((customer) => {
    const memberId = customer?.member_id || customer?.phone || "";

    return {
      value: customer.id,
      label: customer.name,
      phone: customer.phone || "",
      member_id: memberId,
      searchText: [customer.name, customer.phone, memberId].filter(Boolean).join(" ").toLowerCase(),
    };
  });

  const filterCustomerOption = (option, inputValue) => {
    const keyword = String(inputValue || "")
      .toLowerCase()
      .trim();
    if (!keyword) return true;

    return option?.data?.searchText?.includes(keyword);
  };

  const formatCustomerOption = (option) => (
    <div className="d-flex flex-column">
      <span className="fw-bold">
        {option.label}
        {option.phone || option.member_id ? (
          <span className="fw-normal text-secondary  ms-3">({option.phone || option.member_id})</span>
        ) : null}
      </span>
    </div>
  );

  return (
    <div
      className="page-wrapper pos-layout"
      style={{
        marginLeft: 0,
      }}>
      {/* <OverlayLoading isShow={isLoading || (isCashierShiftEnabled && cashierShiftLoading)} /> */}
      <CartRecoveryModal recovery={recovery} onViewSales={() => navigate(PATH_URL.SALE)} />
      {recovery.warnings.length > 0 ? (
        <div className="container-xl pt-2">
          <div className="alert alert-warning mb-2" role="status">
            <div className="d-flex justify-content-between align-items-center gap-2">
              <strong>Ada perubahan pada keranjang</strong>
              <button
                type="button"
                className="btn-close"
                aria-label="Tutup informasi pemulihan"
                onClick={recovery.dismissWarnings}
              />
            </div>
            <ul className="mb-0 mt-2 ps-3">
              {recovery.warnings.map((message, index) => (
                <li key={index}>{message}</li>
              ))}
            </ul>
          </div>
        </div>
      ) : null}
      {isEditingSale ? (
        <div className="container-xl pt-3">
          <div className="pos-edit-sale-banner" role="status">
            <span className="pos-edit-sale-icon" aria-hidden="true">
              <i className="ti ti-pencil" />
            </span>
            <div className="flex-fill min-w-0">
              <strong>
                {editSaleLoading ? "Memuat transaksi..." : `Mengubah ${editingSale?.invoice_no || "transaksi"}`}
              </strong>
              <p className="mb-0">
                Produk, pelanggan, diskon, dan catatan dapat diubah. Pembayaran yang sudah diterima tetap dikunci.
              </p>
            </div>
            <button type="button" className="btn btn-ghost-secondary btn-sm" onClick={() => navigate(PATH_URL.SALE)}>
              Batal
            </button>
          </div>
        </div>
      ) : null}
      <div className="page-header d-print-none d-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h1 className="page-title fs-1 text-capitalize">Kasir</h1>
              <div className="page-pretitle">penjualan</div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                <button
                  type="button"
                  className="btn btn-primary btn-5 d-none d-sm-inline-block"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  //   onClick={openModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                  Tambah produk
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-6 d-sm-none btn-icon"
                  data-bs-toggle="modal"
                  data-bs-target="#modal-form"
                  //   onClick={openModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-2">
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body pos-page-body">
        <div className="container-xl">
          <div className="row row-deck row-cards">
            <div
              className="col-lg-8 pos-catalog-column"
              style={{
                position: "sticky",
                top: "2rem",
              }}>
              <div className="card pos-catalog-card">
                {" "}
                <div className="card-table">
                  <div className="card-header pos-catalog-header">
                    <div className="row w-full justify-content-between align-items-center pos-catalog-toolbar">
                      <div className="col-md-4 col-6">
                        <h3 className="card-title mb-0">Produk</h3>
                        <p className="text-secondary m-0">{userProfile?.pos_stock_source === "seller" ? "Stok pegangan sendiri" : "Tambahkan ke keranjang"}</p>
                      </div>
                      <div className="col-md-2 col-6 my-md-0 my-2 d-flex justify-content-end d-md-none">
                        <div>
                          <nav className="nav nav-segmented nav-2 pos-view-toggle" aria-label="Tampilan produk">
                            <button
                              type="button"
                              className={`nav-link ${viewMode === "grid" ? "active" : ""}`}
                              aria-label="Tampilan grid"
                              title="Tampilan grid"
                              aria-pressed={viewMode === "grid"}
                              onClick={() => setViewMode("grid")}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-layout-dashboard">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
                                <path d="M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
                                <path d="M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
                                <path d="M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              className={`nav-link ${viewMode === "table" ? "active" : ""}`}
                              aria-label="Tampilan daftar"
                              title="Tampilan daftar"
                              aria-pressed={viewMode === "table"}
                              onClick={() => setViewMode("table")}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon nav-link-icon icon-2">
                                <path d="M9 6l11 0"></path>
                                <path d="M9 12l11 0"></path>
                                <path d="M9 18l11 0"></path>
                                <path d="M5 6l0 .01"></path>
                                <path d="M5 12l0 .01"></path>
                                <path d="M5 18l0 .01"></path>
                              </svg>
                            </button>
                          </nav>
                        </div>
                      </div>
                      <div className="col-md-6 col-12 my-md-0 my-2 pos-search-column">
                        <div className="input-group input-group-flat w-auto">
                          {catalogLoading ? (
                            <span className="input-group-text">
                              <div
                                className="spinner-border spinner-border-sm text-primary text-center"
                                role="status"></div>
                            </span>
                          ) : (
                            <span className="input-group-text">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-1">
                                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                <path d="M21 21l-6 -6" />
                              </svg>
                            </span>
                          )}

                          <input
                            id="advanced-table-search"
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleSearchChange}
                            placeholder="Cari..."
                            value={filterText}
                          />
                        </div>
                      </div>
                      <div className="col-md-2 col-6 my-md-0 my-2 d-md-flex justify-content-end d-none">
                        <div>
                          <nav className="nav nav-segmented nav-2 pos-view-toggle" aria-label="Tampilan produk">
                            <button
                              type="button"
                              className={`nav-link ${viewMode === "grid" ? "active" : ""}`}
                              aria-label="Tampilan grid"
                              title="Tampilan grid"
                              aria-pressed={viewMode === "grid"}
                              onClick={() => setViewMode("grid")}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-layout-dashboard">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M5 4h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
                                <path d="M5 16h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
                                <path d="M15 12h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1" />
                                <path d="M15 4h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1" />
                              </svg>
                            </button>
                            <button
                              type="button"
                              className={`nav-link ${viewMode === "table" ? "active" : ""}`}
                              aria-label="Tampilan daftar"
                              title="Tampilan daftar"
                              aria-pressed={viewMode === "table"}
                              onClick={() => setViewMode("table")}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon nav-link-icon icon-2">
                                <path d="M9 6l11 0"></path>
                                <path d="M9 12l11 0"></path>
                                <path d="M9 18l11 0"></path>
                                <path d="M5 6l0 .01"></path>
                                <path d="M5 12l0 .01"></path>
                                <path d="M5 18l0 .01"></path>
                              </svg>
                            </button>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!catalogLoading && productCategoryOptions.length > 0 ? (
                    <div className="pos-category-filter mt-1" aria-label="Filter kategori produk">
                      <div className="pos-category-scroll " role="group">
                        <button
                          type="button"
                          className={`btn btn-sm rounded-pill pos-category-pill fs-6 fw-bold text-lowercase ${
                            selectedProductCategory === ALL_PRODUCT_CATEGORIES
                              ? "btn-primary text-white is-active"
                              : "btn-outline-secondary"
                          }`}
                          aria-pressed={selectedProductCategory === ALL_PRODUCT_CATEGORIES}
                          onClick={() => setSelectedProductCategory(ALL_PRODUCT_CATEGORIES)}>
                          Semua
                        </button>
                        {productCategoryOptions.map((category) => {
                          const isActive = selectedProductCategory === category.value;

                          return (
                            <button
                              key={category.value}
                              type="button"
                              className={`btn btn-sm rounded-pill pos-category-pill fs-6 fw-bold text-lowercase ${
                                isActive ? "btn-primary text-white is-active" : "btn-outline-secondary"
                              }`}
                              aria-pressed={isActive}
                              onClick={() => setSelectedProductCategory(category.value)}>
                              {category.label}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className="pos-category-filter mt-1 w-100" aria-label="Filter kategori produk">
                      <div className="pos-category-scroll" role="group">
                        {Array.from({ length: 10 }).map((_, index) => (
                          <div
                            className="placeholder"
                            style={{
                              height: "1.6rem",
                              minWidth: "6rem",
                              marginRight: "0.4rem",
                              borderRadius: "50px",
                            }}></div>
                        ))}
                      </div>
                    </div>
                  )}
                  {viewMode === "table" ? (
                    <ProductListView
                      key={selectedProductCategory}
                      products={visibleProducts}
                      loading={catalogLoading}
                      search={filterText}
                      onSelect={selectCatalogProduct}
                    />
                  ) : (
                    <div className="advanced-grid pos-product-grid mt-3 mb-3 mx-3 pb-2 ">
                      <div
                        key={selectedProductCategory}
                        className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-3 gx-3 gy-3 pos-product-grid-row"
                        style={{
                          overflowY: "scroll",
                          maxHeight: "68vh",
                          scrollbarWidth: "thin",
                        }}>
                        {catalogLoading ? (
                          <ProductGridSkeleton />
                        ) : (
                          visibleProducts.map((product, productIndex) => {
                            const remainingStock = product?.remaining_stock;
                            const isOutOfStock = product?.is_product_group
                              ? !product?.can_sell
                              : Number(remainingStock || 0) <= 0;
                            const canOpenProduct = !isOutOfStock || canOpenCatalogProduct(product);
                            const isLowStock =
                              !isOutOfStock &&
                              !product?.is_unlimited &&
                              Number.isFinite(Number(remainingStock)) &&
                              Number(remainingStock) <= Math.max(2, Number(product?.min_stock || 0));

                            return (
                              <div
                                key={product.id}
                                className="col pos-product-grid-item"
                                style={{ "--pos-product-delay": `${Math.min(productIndex, 8) * 32}ms` }}>
                                <div
                                  className={`card card-sm h-100 border-1 border-primary overflow-hidden pos-product-card ${
                                    isOutOfStock ? "is-out-of-stock" : ""
                                  } ${canOpenProduct ? "clickable-card" : ""} ${isLowStock ? "is-low-stock" : ""}`}
                                  style={{
                                    cursor: canOpenProduct ? "pointer" : "not-allowed",
                                    transition: "transform 0.1s ease",
                                  }}
                                  onClick={(event) => {
                                    if (canOpenProduct) {
                                      selectCatalogProduct(product, event.currentTarget);
                                    }
                                  }}
                                  role="button"
                                  tabIndex={canOpenProduct ? 0 : -1}
                                  aria-disabled={!canOpenProduct}
                                  aria-label={`${product?.name}, ${
                                    product?.is_product_group
                                      ? `${product?.variant_count || 0} pilihan varian`
                                      : product?.is_unlimited
                                        ? "tanpa batas stok"
                                        : `stok tersisa ${remainingStock} ${product?.unit || ""}`
                                  }${isOutOfStock && canOpenProduct ? ", lihat penyebab tidak tersedia" : ""}`}
                                  onKeyDown={(event) => {
                                    if (canOpenProduct && (event.key === "Enter" || event.key === " ")) {
                                      event.preventDefault();
                                      selectCatalogProduct(product, event.currentTarget);
                                    }
                                  }}
                                  onMouseDown={(e) => {
                                    if (canOpenProduct) {
                                      e.currentTarget.style.transform = "scale(0.96)";
                                    }
                                  }}
                                  onMouseUp={(e) => {
                                    if (canOpenProduct) {
                                      e.currentTarget.style.transform = "scale(1)";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (canOpenProduct) {
                                      e.currentTarget.style.transform = "scale(1)";
                                    }
                                  }}>
                                  <div
                                    className={`card-body p-0 d-flex flex-column h-100 ${
                                      isOutOfStock ? "" : "clickable-card"
                                    }`}
                                    style={{}}>
                                    {product?.image_path || product?.image ? (
                                      <div className="pos-product-media bg-light overflow-hidden rounded-top position-relative">
                                        <img
                                          src={BASE_URL_STORAGE + (product?.image_path || product?.image)}
                                          alt={product?.name}
                                          className="pos-product-image w-100"
                                          style={{ height: "10rem", objectFit: "cover" }}
                                        />

                                        <div
                                          className="bg-white small d-flex align-items-center gap-2 flex-wrap position-absolute m-1 text-primary rounded pos-product-category-badge"
                                          style={{
                                            bottom: "5px",
                                            left: "5px",
                                          }}>
                                          <span className="d-flex align-items-center gap-1 fw-bold p-1 fs-6">
                                            <TablerIcon name="category" size={12} />
                                            {getProductCategoryName(product)}
                                          </span>
                                        </div>
                                        {canCreateProductions &&
                                        !product?.is_product_group &&
                                        product?.inventory_mode === "stocked" ? (
                                          <button
                                            key={`stock-${product.id}-${remainingStock}`}
                                            type="button"
                                            className={`pos-product-stock-badge bg-white small d-flex align-items-center gap-2 flex-wrap position-absolute m-1 text-primary rounded-pill ${
                                              isLowStock ? "is-low-stock" : ""
                                            }`}
                                            style={{
                                              top: "5px",
                                              right: "5px",
                                              border: "1px solid var(--tblr-border-color)",
                                            }}
                                            data-bs-toggle={"modal"}
                                            data-bs-target={"#modal-form-production"}
                                            onClick={(event) => {
                                              event.preventDefault();
                                              event.stopPropagation();
                                              setProductionState({
                                                id: product?.id,
                                                name: product?.name,
                                                type: product?.type,
                                                category: product?.category,
                                                weight: product?.weight,
                                                unit: product?.unit,
                                                unit_price: product?.unit_price,
                                                stock: product?.stock,
                                                min_stock: product?.min_stock,
                                                image: product?.image,
                                                image_path: product?.image,
                                                image_url: product?.image,
                                                materials: product?.materials,
                                                qty_production: 1,
                                              });
                                              setIsShowModal(true);
                                            }}>
                                            <span className="d-flex align-items-center gap-1 fw-bold p-1 fs-6">
                                              <TablerIcon name="package" size={12} />
                                              {product?.is_product_group
                                                ? `${product?.variant_count || 0} varian`
                                                : product?.is_unlimited
                                                  ? "Tanpa stok"
                                                  : `${remainingStock} ${product?.unit || ""}`}
                                            </span>
                                          </button>
                                        ) : (
                                          <span
                                            key={`stock-${product.id}-${remainingStock}`}
                                            className={`pos-product-stock-badge bg-white small d-flex align-items-center position-absolute m-1 text-primary rounded-pill ${
                                              isLowStock ? "is-low-stock" : ""
                                            }`}>
                                            <span className="d-flex align-items-center gap-1 fw-bold p-1 fs-6">
                                              <TablerIcon name="package" size={12} />
                                              {product?.is_product_group
                                                ? `${product?.variant_count || 0} varian`
                                                : product?.is_unlimited
                                                  ? "Tanpa stok"
                                                  : `${remainingStock} ${product?.unit || ""}`}
                                            </span>
                                          </span>
                                        )}
                                      </div>
                                    ) : (
                                      <div
                                        className="pos-product-media bg-primary-lt d-flex align-items-center justify-content-center rounded-top position-relative"
                                        style={{ height: "10rem" }}>
                                        <div className="text-center pos-product-placeholder">
                                          <TablerIcon name="package" size={48} className="text-primary mb-2" />
                                          <div className="small text-muted">No Image</div>
                                        </div>
                                        <div
                                          className="bg-white small d-flex align-items-center gap-2 flex-wrap position-absolute m-1 text-primary rounded pos-product-category-badge"
                                          style={{
                                            bottom: "5px",
                                            left: "5px",
                                          }}>
                                          <span className="d-flex align-items-center gap-1 fw-bold p-1 fs-6">
                                            <TablerIcon name="category" size={12} />
                                            {getProductCategoryName(product)}
                                          </span>
                                        </div>
                                        {canCreateProductions &&
                                        !product?.is_product_group &&
                                        product?.inventory_mode === "stocked" ? (
                                          <button
                                            key={`stock-${product.id}-${remainingStock}`}
                                            type="button"
                                            className={`pos-product-stock-badge bg-white small d-flex align-items-center gap-2 flex-wrap position-absolute m-1 text-primary rounded-pill ${
                                              isLowStock ? "is-low-stock" : ""
                                            }`}
                                            style={{
                                              top: "5px",
                                              right: "5px",
                                              border: "1px solid var(--tblr-border-color)",
                                            }}
                                            data-bs-toggle={"modal"}
                                            data-bs-target={"#modal-form-production"}
                                            onClick={(event) => {
                                              event.preventDefault();
                                              event.stopPropagation();
                                              setProductionState({
                                                id: product?.id,
                                                name: product?.name,
                                                type: product?.type,
                                                category: product?.category,
                                                weight: product?.weight,
                                                unit: product?.unit,
                                                unit_price: product?.unit_price,
                                                stock: product?.stock,
                                                min_stock: product?.min_stock,
                                                image: product?.image,
                                                image_path: product?.image,
                                                image_url: product?.image,
                                                materials: product?.materials,
                                                qty_production: 1,
                                              });
                                              setIsShowModal(true);
                                            }}>
                                            <span className="d-flex align-items-center gap-1 fw-bold p-1 fs-6">
                                              <TablerIcon name="package" size={12} />
                                              {product?.is_product_group
                                                ? `${product?.variant_count || 0} varian`
                                                : product?.is_unlimited
                                                  ? "Tanpa stok"
                                                  : `${remainingStock} ${product?.unit || ""}`}
                                            </span>
                                          </button>
                                        ) : (
                                          <span
                                            key={`stock-${product.id}-${remainingStock}`}
                                            className={`pos-product-stock-badge bg-white small d-flex align-items-center position-absolute m-1 text-primary rounded-pill ${
                                              isLowStock ? "is-low-stock" : ""
                                            }`}>
                                            <span className="d-flex align-items-center gap-1 fw-bold p-1 fs-6">
                                              <TablerIcon name="package" size={12} />
                                              {product?.is_product_group
                                                ? `${product?.variant_count || 0} varian`
                                                : product?.is_unlimited
                                                  ? "Tanpa stok"
                                                  : `${remainingStock} ${product?.unit || ""}`}
                                            </span>
                                          </span>
                                        )}
                                      </div>
                                    )}

                                    <div
                                      className="pos-product-info d-flex flex-column flex-grow-1 p-3"
                                      style={{
                                        opacity: isOutOfStock ? "0.55" : "1",
                                      }}>
                                      <div className="mt-3 ">
                                        <div className="pos-product-name fw-bold  line-clamp-2 mb-1">
                                          {product?.name}
                                        </div>
                                        {/* <div className="text-muted small">
                                          {product?.is_product_group && product?.variant_count > 1
                                            ? `${product.variant_count} pilihan ${product?.option_name || "varian"}`
                                            : product?.sku}
                                        </div> */}
                                      </div>

                                      <div className="mt-auto d-flex justify-content-between align-items-center">
                                        <div className="pos-product-price  mb-1 text-primary fw-bold">
                                          {product?.is_product_group &&
                                          product?.minimum_price !== product?.maximum_price
                                            ? "Mulai "
                                            : ""}
                                          {formatIDR(product?.unit_price)}
                                        </div>
                                        {/* <button
                                          type="button"
                                          className="btn btn-primary btn-sm text-white d-none d-lg-block"
                                          disabled={!canOpenProduct}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-plus text-white">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M12 5l0 14" />
                                            <path d="M5 12l14 0" />
                                          </svg>{" "}
                                          {isOutOfStock
                                            ? canOpenProduct
                                              ? "Lihat"
                                              : "Habis"
                                            : product?.variant_count > 1
                                              ? "Pilih"
                                              : "Tambah"}
                                        </button> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                      {visibleProducts.length === 0 && !catalogLoading ? (
                        <div className="col-12 my-5">
                          <div className="text-center text-secondary py-5">
                            <span className="h1 fw-bold">
                              {filterText ? "Produk tidak ditemukan." : "Belum ada produk pada kategori ini."}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isMobileCartExpanded ? (
              <button
                type="button"
                className="pos-cart-backdrop d-lg-none mt-0"
                aria-label="Tutup keranjang"
                onClick={closeMobileCart}></button>
            ) : null}
            <div
              ref={mobileCartDrag.panelRef}
              className={`col-lg-4 pos-cart-column ${hasCartItems ? "has-items" : ""} ${
                isMobileCartExpanded ? "is-open" : ""
              }`}
              style={{
                // sticky top 0
                position: "sticky",
                top: "2rem",
                maxHeight: "90vh",
              }}>
              <div
                className="card pos-cart-card pb-2"
                style={
                  {
                    // maxHeight: "100vh",
                  }
                }>
                <div
                  className={`card-header pos-cart-header ${isCartReceivingItem ? "is-receiving-product" : ""}`}
                  role="button"
                  tabIndex="0"
                  {...mobileCartDrag.dragHandlers}
                  onClick={() => {
                    if (mobileCartDrag.consumeDragClick()) return;

                    toggleMobileCart();
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      toggleMobileCart();
                    }
                  }}>
                  <span className="pos-cart-handle d-lg-none"></span>
                  <div className="card-title d-flex align-items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-shopping-cart">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M4 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M15 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                      <path d="M17 17h-11v-14h-2" />
                      <path d="M6 5l14 1l-1 7h-13" />
                    </svg>
                    Keranjang
                  </div>
                  <div className="card-actions">
                    <span ref={cartTargetRef} className="badge bg-primary text-white pos-cart-target">
                      {formState?.details?.length} item
                    </span>
                    <AnimatedCurrency value={formState?.total} className="d-lg-none ms-2 fw-bold text-primary" />
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      className={`d-lg-none pos-cart-chevron mx-3 ${isMobileCartExpanded ? "is-open" : ""}`}>
                      <path d="M6 15l6-6l6 6" />
                    </svg>
                  </div>
                </div>
                {isCashierShiftEnabled ? (
                  <div className="px-3 pt-3">
                    {hasOpenShift ? (
                      <div className="alert alert-success bg-primary-lt border-0 mb-3">
                        <div className="d-flex align-items-start justify-content-between gap-3">
                          <div>
                            <div className="fw-bold text-primary d-flex align-items-center gap-2">
                              <TablerIcon name="cash-register" size={18} />
                              Shift Kasir Aktif
                            </div>
                            <div className="small text-muted mt-1">
                              Dibuka:{" "}
                              {currentCashierShift?.opened_at
                                ? new Date(currentCashierShift.opened_at).toLocaleString("id-ID")
                                : "-"}
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-outline-primary btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-close-shift">
                            Tutup Shift
                          </button>
                        </div>
                        <div className="row g-2 mt-3">
                          <div className="col-6">
                            <div className="small text-muted">Tunai</div>
                            <div className="fw-bold">{formatIDR(currentShiftSummary?.cash_sales_total || 0)}</div>
                          </div>
                          <div className="col-6">
                            <div className="small text-muted">Non-Tunai</div>
                            <div className="fw-bold">{formatIDR(currentShiftSummary?.non_cash_sales_total || 0)}</div>
                          </div>
                          <div className="col-6">
                            <div className="small text-muted">Transaksi</div>
                            <div className="fw-bold">{currentShiftSummary?.transaction_count || 0}x</div>
                          </div>
                          <div className="col-6">
                            <div className="small text-muted">Estimasi Kas</div>
                            <div className="fw-bold text-primary">{formatIDR(expectedClosingCash)}</div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="alert alert-warning bg-warning-lt border-0 mb-3">
                        <div className="d-flex align-items-start justify-content-between gap-3">
                          <div>
                            <div className="fw-bold text-warning d-flex align-items-center gap-2">
                              <TablerIcon name="alert-triangle" size={18} />
                              Shift belum dibuka
                            </div>
                            <div className="small text-muted mt-1">
                              Buka shift dulu sebelum checkout. Draft masih bisa disimpan.
                            </div>
                          </div>
                          <button
                            type="button"
                            className="btn btn-warning btn-sm text-white"
                            data-bs-toggle="modal"
                            data-bs-target="#modal-open-shift">
                            Buka Shift
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                ) : null}

                <div
                  className="card-body p-0"
                  style={{
                    // height: "10.5vh",
                    overflowY: "auto",
                  }}>
                  <div
                    className="table-responsive pos-cart-items-scroll"
                    role="region"
                    aria-label="Daftar item keranjang"
                    tabIndex={0}
                    style={{
                      // height: "50.5vh",
                      overflowY: "auto",
                    }}>
                    <table className="table table-vcenter card-table">
                      <tbody
                        style={{
                          border: "0px solid inherit",
                          borderStyle: "none",
                        }}>
                        {formState?.details.length === 0 ? (
                          <tr className="">
                            <td
                              colSpan="4"
                              className="text-center py-4 text-muted d-flex flex-column align-items-center gap-2 fs-6 fw-bold">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icons-tabler-outline icon-tabler-shopping-cart-off">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M4 19a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                                <path d="M17 17a2 2 0 1 0 2 2" />
                                <path d="M17 17h-11v-11" />
                                <path d="M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7" />
                                <path d="M3 3l18 18" />
                              </svg>
                              Keranjang kosong
                            </td>
                          </tr>
                        ) : (
                          formState?.details?.map((item) => (
                            <tr
                              key={item?.product_id}
                              className="pos-cart-item-row"
                              style={{
                                border: "0px solid inherit",
                                borderStyle: "none",
                              }}>
                              <td data-label="Nama">
                                <button
                                  type="button"
                                  className="pos-cart-item-note-trigger"
                                  data-bs-toggle="modal"
                                  data-bs-target="#modal-cart-item-note"
                                  aria-label={`Tambahkan catatan untuk ${item?.product_name || "produk"}`}
                                  onClick={() => setSelectedCartItem(item)}>
                                  <UserAvatar
                                    fullName={item?.product_name}
                                    imageUrl={item?.image_path || item?.image}
                                    image_path={item?.image_path || item?.image}
                                    size="md"
                                    className="me-2"
                                    justPhotoView={true}
                                  />

                                  <div className="flex-fill text-start min-w-0">
                                    <div className="fs-6 fw-bold">{item?.product_name}</div>
                                    <div className="text-secondary">
                                      <AnimatedCurrency
                                        value={item?.unit_price * item?.qty}
                                        className="text-reset fs-6 fw-bold text-primary"
                                      />
                                    </div>
                                    {item?.note ? (
                                      <div className="pos-cart-item-note-preview" title={item.note}>
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                          <path d="M5 4h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-8l-5 4v-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                                        </svg>
                                        <span>{item.note}</span>
                                      </div>
                                    ) : (
                                      <div className="pos-cart-item-note-empty">+ catatan</div>
                                    )}
                                  </div>
                                </button>
                              </td>
                              <td>
                                {/* <div className="input-group input-group-sm">
                              <input
                              type="number"
                              className="form-control text-center"
                              value={item.qty}
                              onChange={(e) => updateQuantity(item.product_id, parseInt(e.target.value) || 0)}
                              style={{ width: "50px", minWidth: "50px" }}
                              />
                                                           </div> */}
                                <div className="d-flex justify-content-between">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-link text-danger "
                                    aria-label={`Kurangi jumlah ${item?.product_name || "produk"}`}
                                    onClick={() => {
                                      decreaseQuantity(item?.product_id);
                                    }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="icon icon-tabler icons-tabler-outline icon-tabler-minus">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                      <path d="M5 12l14 0" />
                                    </svg>
                                  </button>

                                  <div className="flex-grow-1 m-auto W-100 text-center">
                                    {/* <input
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  className="form-control text-start h1 fw-bold m-0"
                                  style={
                                  {
                                    // border: "none",
                                    // outline: "none",
                                    // boxShadow: "none",
                                  }
                                  }
                                  value={item?.qty}
                                  onChange={(e) => {
                                  setFormState((prev) => ({
                                    ...prev,
                                    qty: e.target.value,
                                  }));
                                  }}
                                  /> */}
                                    <span
                                      key={`${item?.product_id}-${item?.qty}`}
                                      className="text-center h3 fw-bold m-0 w-100 pos-cart-quantity-value">
                                      {item?.qty}
                                    </span>
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-link text-primary"
                                    aria-label={`Tambah jumlah ${item?.product_name || "produk"}`}
                                    disabled={Number(item?.qty || 0) >= Number(item?.stock_available || 0)}
                                    onClick={() => {
                                      increaseQuantity(item?.product_id);
                                    }}>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="icon icon-tabler icons-tabler-outline icon-tabler-plus">
                                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                      <path d="M12 5l0 14" />
                                      <path d="M5 12l14 0" />
                                    </svg>
                                  </button>
                                </div>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-link text-danger p-0"
                                  aria-label={`Hapus ${item?.product_name || "produk"} dari keranjang`}
                                  onClick={() => {
                                    setFormState((prev) => ({
                                      ...prev,
                                      details: prev?.details.filter(
                                        (detail) => detail?.product_id !== item?.product_id,
                                      ),
                                    }));
                                  }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-trash">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M4 7l16 0" />
                                    <path d="M10 11l0 6" />
                                    <path d="M14 11l0 6" />
                                    <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                    <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                  </svg>
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Cart Summary */}
                <div className="card-footer bg-white px-3 pos-cart-summary">
                  <div className="mb-3">
                    {/* <div className="d-flex justify-content-between mb-2">
                        <span className="text-muted">Total Item:</span>
                        <span className="fw-bold">{formState?.details.reduce((sum, i) => sum + i.qty, 0)} pcs</span>
                       </div> */}
                    {isDiscount && (
                      <>
                        <div className="d-flex justify-content-between pt-2 ">
                          <span className="h5 mb-0">Subtotal:</span>
                          <AnimatedCurrency value={formState?.subtotal} className="h5 mb-0 text-primary" />
                        </div>
                        <div className="d-flex justify-content-between pt-2 ">
                          <span className="h5 mb-0">Discount:</span>
                          <span className="h5 mb-0 text-danger">
                            - <AnimatedCurrency value={formState?.discount} />
                          </span>
                        </div>
                      </>
                    )}
                    {formState?.change > 0 && (
                      <div className="d-flex justify-content-between pt-2 ">
                        <span className="h5 mb-0">Kembalian:</span>
                        <AnimatedCurrency value={formState?.change} className="h5 mb-0 text-warning" />
                      </div>
                    )}
                    {formState?.due > 0 && (
                      <div className="d-flex justify-content-between pt-2 ">
                        <span className="h5 mb-0">Sisa Tagihan:</span>
                        <AnimatedCurrency value={formState?.due} className="h5 mb-0 text-danger" />
                      </div>
                    )}
                    <div className="d-flex justify-content-between pt-2 ">
                      <span className="h2 mb-0">Total:</span>
                      <AnimatedCurrency value={formState?.total} className="h2 mb-0 text-primary" />
                    </div>
                    {/* {hasCartItems ? (
                      <div className="d-flex justify-content-end mt-2">
                        <span className={`badge ${isPaymentEnough ? "bg-success-lt" : "bg-warning-lt"}`}>
                          {isPaymentEnough ? "Akan tersimpan Lunas" : "Akan tersimpan Belum Lunas"}
                        </span>
                      </div>
                    ) : null} */}
                  </div>

                  {/* {cartHealthAlerts.length > 0 ? (
                    <div className="alert alert-warning bg-warning-lt border-0 py-2 mb-3">
                      <div className="fw-bold mb-1 d-flex align-items-center gap-1">
                        <TablerIcon name="alert-triangle" size={16} />
                        Cek Keranjang
                      </div>
                      <ul className="mb-0 ps-3 small">
                        {cartHealthAlerts.map((alert, index) => (
                          <li key={`${alert.message}-${index}`} className={alert.type === "danger" ? "text-danger" : ""}>
                            {alert.message}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null} */}

                  {/* Customer Info */}
                  <div className="col-12">
                    <label className="form-label">Customer</label>
                    <div className="mb-3 d-flex gap-2 align-items-stretch">
                      <div className="input-icon flex-fill">
                        <span
                          className="input-icon-addon"
                          style={{
                            zIndex: 1,
                          }}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="icon icon-tabler icons-tabler-outline icon-tabler-users">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                            <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                          </svg>
                        </span>
                        <Select
                          options={optionCustomers || []}
                          name="unit"
                          className="form-select p-0 pos-customer-select"
                          classNamePrefix="pos-customer"
                          filterOption={filterCustomerOption}
                          formatOptionLabel={formatCustomerOption}
                          styles={{
                            control: (base) => ({
                              ...base,
                              paddingLeft: "2rem",
                              border: "none",
                              borderRadius: "8px",
                              boxShadow: "none",
                              minHeight: "38px",
                              "&:hover": {
                                border: "none",
                                boxShadow: "none",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#e3f2fd",
                              borderRadius: "20px",
                              padding: "2px 8px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "#a7f3d0",
                              fontWeight: "500",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "#a7f3d0",
                              ":hover": {
                                backgroundColor: "#bbdefb",
                                color: "#a7f3d0",
                              },
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 2,
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#90a4ae",
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isSelected
                                ? "#32CD32" // item yang dipilih
                                : state.isFocused
                                  ? "#90EE90" // saat hover
                                  : "#FFF", // default
                              color: state.isSelected
                                ? "#FFF" // item yang dipilih
                                : state.isFocused
                                  ? "#000" // saat hover
                                  : "#000", // default
                              cursor: "pointer",
                            }),
                          }}
                          value={
                            formState?.customer_id
                              ? optionCustomers.find((option) => option.value === formState?.customer_id)
                              : null
                          }
                          onChange={(selectedOptions) => {
                            setFormState({
                              ...formState,
                              customer_id: selectedOptions?.value || "",
                              customer_name: selectedOptions?.label || "",
                              customer_phone: selectedOptions?.phone || "",
                            });
                          }}
                          placeholder="- Customer / No HP -"
                        />
                      </div>
                      <button
                        type="button"
                        className="btn btn-icon btn-white rounded-3"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-pos-customer"
                        onClick={openCustomerModal}
                        aria-label="Tambah customer">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                          <path d="M6 21v-2a4 4 0 0 1 4 -4h3" />
                          <path d="M19 17v6" />
                          <path d="M16 20h6" />
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Discount Input */}
                  <div className="mt-3">
                    <div className="d-flex justify-content-between">
                      <label className="form-label">Diskon</label>
                      {/* toggle button */}
                      <label className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isDiscount}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setIsDiscount(checked);
                            setFormState((previous) => ({
                              ...previous,
                              discount: checked ? (Number(previous.discount || 0) > 0 ? previous.discount : "") : 0,
                            }));
                          }}
                        />
                      </label>
                    </div>
                    {isDiscount && (
                      <div className="input-group mb-3">
                        <span className="input-group-text bg-danger text-white">Rp</span>
                        <NumberInput
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          className="form-control form-control-lg"
                          value={formState?.discount ?? ""}
                          min="0"
                          max={Number(formState?.subtotal || 0)}
                          onChange={(e) => {
                            const value = normalizeCurrencyInput(e.target.value);
                            setFormState((previous) => ({ ...previous, discount: value }));
                          }}
                          placeholder="0"
                        />
                      </div>
                    )}
                    {discountExceedsSubtotal ? (
                      <div className="alert alert-danger py-2 px-3" role="alert">
                        Diskon maksimal {formatIDR(formState?.subtotal || 0)}. Draft dan pembayaran tidak dapat disimpan
                        sebelum nominal diperbaiki.
                      </div>
                    ) : null}
                  </div>

                  {/* Payment Method */}
                  <div className="mb-3">
                    <label className="form-label">Metode Pembayaran</label>
                    <div className="form-selectgroup form-selectgroup-boxes d-flex flex-row gap-3">
                      <label
                        className={`form-selectgroup-item flex-fill pos-payment-option ${
                          formState.payment_method === "cash" ? "is-active" : ""
                        }`}
                        style={{
                          width: "20px",
                        }}>
                        <input
                          type="radio"
                          name="cash"
                          value="cash"
                          className="form-selectgroup-input"
                          checked={formState.payment_method === "cash"}
                          onChange={handlePaymentMethodChange}
                          disabled={isSubmittingSale || (isEditingSale && !canPayEditedSale)}
                          defaultChecked
                        />

                        <div className="form-selectgroup-label d-flex align-items-center p-2">
                          <div className="me-2">
                            <span className="form-selectgroup-check"></span>
                          </div>
                          <div className="d-flex flex-row ">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-cash-banknote me-1">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                              <path d="M3 8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -8" />
                              <path d="M18 12h.01" />
                              <path d="M6 12h.01" />
                            </svg>
                            <span className="fs-6 text-muted fw-bold  d-md-flex d-lg-none d-xl-flex ">Tunai</span>
                          </div>
                        </div>
                      </label>

                      <label
                        className={`form-selectgroup-item flex-fill pos-payment-option ${
                          formState.payment_method === "qris" ? "is-active" : ""
                        }`}
                        style={{
                          width: "20px",
                        }}>
                        <input
                          type="radio"
                          name="qris"
                          value="qris"
                          className="form-selectgroup-input"
                          checked={formState.payment_method === "qris"}
                          onChange={handlePaymentMethodChange}
                          disabled={isSubmittingSale || (isEditingSale && !canPayEditedSale)}
                        />

                        <div className="form-selectgroup-label d-flex align-items-center p-2">
                          <div className="me-2">
                            <span className="form-selectgroup-check"></span>
                          </div>
                          <div className="d-flex flex-row">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-qrcode me-1">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" />
                              <path d="M7 17l0 .01" />
                              <path d="M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" />
                              <path d="M7 7l0 .01" />
                              <path d="M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -4" />
                              <path d="M17 7l0 .01" />
                              <path d="M14 14l3 0" />
                              <path d="M20 14l0 .01" />
                              <path d="M14 14l0 3" />
                              <path d="M14 20l3 0" />
                              <path d="M17 17l3 0" />
                              <path d="M20 17l0 3" />
                            </svg>
                            <span className="fs-6 text-muted fw-bold  d-md-flex d-lg-none d-xl-flex ">QRIS</span>
                          </div>
                        </div>
                      </label>

                      <label
                        className={`form-selectgroup-item flex-fill pos-payment-option ${
                          formState.payment_method === "transfer" ? "is-active" : ""
                        }`}
                        style={{
                          width: "20px",
                        }}>
                        <input
                          type="radio"
                          name="transfer"
                          value="transfer"
                          className="form-selectgroup-input"
                          checked={formState.payment_method === "transfer"}
                          onChange={handlePaymentMethodChange}
                          disabled={isSubmittingSale || (isEditingSale && !canPayEditedSale)}
                        />

                        <div className="form-selectgroup-label d-flex align-items-center p-2">
                          <div className="me-1">
                            <span className="form-selectgroup-check"></span>
                          </div>
                          <div className="d-flex flex-row">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-transfer me-1">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                              <path d="M20 10h-16l5.5 -6" />
                              <path d="M4 14h16l-5.5 6" />
                            </svg>
                            <span className="fs-6 text-muted fw-bold  d-md-flex d-lg-none d-xl-flex ">Transfer</span>
                          </div>
                        </div>
                      </label>
                    </div>
                    {formState.payment_method === "qris" && (
                      <div className="pos-payment-details-reveal">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-white rounded-2 mt-md-2 mt-0"
                          style={{
                            fontSize: "0.7rem",
                            padding: "0.5rem 0.3rem",
                          }}
                          data-bs-toggle="modal"
                          disabled={editSaleLoading || paymentPreviewAmount <= 0 || editPaymentError || (isEditingSale && !canPayEditedSale)}
                          data-bs-target="#qrisModal">
                          {isEditingSale ? "QRIS pembayaran tambahan" : "Tampilkan QRIS ?"}
                        </button>
                      </div>
                    )}
                    {formState.payment_method === "transfer" && (
                      <div className="pos-payment-details-reveal">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-white rounded-2 mt-md-2 mt-0"
                          style={{
                            fontSize: "0.7rem",
                            padding: "0.5rem 0.3rem",
                          }}
                          data-bs-toggle="modal"
                          disabled={isSubmittingSale || editPaymentError || (isEditingSale && !canPayEditedSale)}
                          data-bs-target="#transferAccountModal">
                          Tampilkan Rekening ?
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Payment Input */}
                  <div className="mb-0">
                    <div className="d-flex justify-content-between align-items-center">
                      <label className="form-label">{isEditingSale ? "Pembayaran Tambahan" : "Jumlah Bayar"}</label>
                    </div>
                    <div key={formState.payment_method} className="input-group pos-payment-amount">
                      <span className="input-group-text bg-primary text-white">Rp</span>
                      <NumberInput
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control form-control-lg"
                        value={formState?.pay ?? ""}
                        min="0"
                        disabled={isSubmittingSale || (isEditingSale && !canPayEditedSale)}
                        onChange={(e) => {
                          const value = normalizeCurrencyInput(e.target.value);
                          paymentAmountEditedRef.current = true;
                          setFormState((previous) => ({ ...previous, pay: value }));
                        }}
                        placeholder="0"
                      />
                    </div>
                    {isEditingSale ? (
                      <div className="form-hint mt-1 pos-payment-details-reveal" style={{ fontSize: "0.65rem" }}>
                        Sudah dibayar {formatIDR(recordedPayment)} · Sisa sebelum pembayaran {formatIDR(remainingBeforePayment)}.
                        {!canPayEditedSale ? " Anda hanya dapat menyimpan perubahan tanpa pembayaran." : " Isi nominal tambahan, lalu pilih Simpan & Bayar."}
                      </div>
                    ) : isAutomaticPaymentMethod(formState.payment_method) ? (
                      <div className="form-hint mt-1 pos-payment-details-reveal " style={{ fontSize: "0.6rem" }}>
                        Terisi otomatis dari total transaksi dan tetap dapat disesuaikan.
                      </div>
                    ) : null}
                    {formState.payment_method === "cash" && (!isEditingSale || canPayEditedSale) && (
                      <div className="d-flex flex-wrap gap-2 mt-2 pos-payment-details-reveal">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-white rounded-2 fs-6"
                          onClick={() => setPaymentAmount(remainingBeforePayment)}>
                          Uang Pas
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-white rounded-2 fs-6"
                          onClick={() => setPaymentAmount(50000)}>
                          50rb
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-white rounded-2 fs-6"
                          onClick={() => setPaymentAmount(100000)}>
                          100rb
                        </button>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-white rounded-2 fs-6"
                          onClick={() => setPaymentAmount(150000)}>
                          150rb
                        </button>
                      </div>
                    )}
                    {editPaymentError ? <div className="text-danger small mt-1" role="alert">Pembayaran QRIS/Transfer tidak boleh melebihi sisa tagihan.</div> : null}
                    {editedTotalBelowPaid ? (
                      <div className="alert alert-danger py-2 px-3 mt-2 mb-0" role="alert">
                        Total transaksi minimal {formatIDR(editingSale?.pay || 0)}, sesuai pembayaran yang sudah
                        diterima.
                      </div>
                    ) : null}
                  </div>

                  <div className="mt-3">
                    <div className="d-flex justify-content-between">
                      <label className="form-label">Catatan</label>
                      <label className="form-check form-switch">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isNoteEnabled}
                          onChange={(event) => {
                            const checked = event.target.checked;
                            setIsNoteEnabled(checked);
                            if (!checked) {
                              setFormState({
                                ...formState,
                                note: "",
                              });
                            }
                          }}
                        />
                      </label>
                    </div>
                    {isNoteEnabled && (
                      <>
                        <textarea
                          className="form-control"
                          rows={3}
                          value={formState?.note || ""}
                          onChange={(event) =>
                            setFormState({
                              ...formState,
                              note: event.target.value,
                            })
                          }
                          placeholder="Contoh: pesanan tanpa gula, nama customer"
                        />
                      </>
                    )}
                  </div>

                  {/* Action Buttons */}
                  {isEditingSale ? (
                    <div className="d-flex flex-wrap gap-2 mt-3 pos-cart-actions">
                      <button
                        type="button"
                        className="btn btn-outline-primary flex-fill"
                        onClick={() => handleUpdateSale()}
                        disabled={
                          editSaleLoading ||
                          isLoading ||
                          isSubmittingSale ||
                          formState?.details.length === 0 ||
                          hasBlockingCartAlert ||
                          discountExceedsSubtotal ||
                          editedTotalBelowPaid
                        }>
                        <i className="ti ti-device-floppy" />
                        {isSubmittingSale ? "Menyimpan..." : "Simpan Perubahan"}
                      </button>
                      {canPayEditedSale ? (
                        <button type="button" className="btn btn-primary flex-fill"
                          data-bs-toggle="modal" data-bs-target="#modal-confirm-edit-payment"
                          disabled={editSaleLoading || isLoading || isSubmittingSale || !hasCartItems || hasBlockingCartAlert
                            || discountExceedsSubtotal || editedTotalBelowPaid || editPaymentError
                            || paymentPreviewAmount <= 0 || !Number.isInteger(paymentPreviewAmount) || remainingBeforePayment <= 0}>
                          <i className="ti ti-check" />
                          {isSubmittingSale ? "Memproses..." : "Simpan & Bayar"}
                        </button>
                      ) : null}
                    </div>
                  ) : (
                    <div className="d-flex gap-2 mt-3 pos-cart-actions">
                      <button
                        type="button"
                        className="btn btn-outline-primary w-25 "
                        data-bs-toggle="modal"
                        data-bs-target="#modal-confirm-draft-sale"
                        disabled={
                          isLoading || isSubmittingSale || formState?.details.length === 0 || discountExceedsSubtotal
                        }>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M6 4h10l2 2v14h-12z" />
                          <path d="M10 4v6h4v-6" />
                          <path d="M9 16h6" />
                        </svg>
                        {isSubmittingSale ? "Menyimpan..." : "Draft"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary w-75"
                        onClick={() => {
                          if (isPaymentEnough) {
                            handlePay();
                          }
                        }}
                        data-bs-toggle={!isPaymentEnough ? "modal" : ""}
                        data-bs-target={!isPaymentEnough ? "#modal-confirm-unpaid-sale" : ""}
                        disabled={
                          isLoading ||
                          isSubmittingSale ||
                          !hasOpenShift ||
                          formState?.details.length === 0 ||
                          discountExceedsSubtotal ||
                          Number(formState?.total || 0) <= 0
                        }>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-cash">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M7 15h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v3" />
                          <path d="M7 10a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -8" />
                          <path d="M12 14a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                        </svg>
                        {isSubmittingSale ? "Memproses..." : isPaymentEnough ? "Bayar Lunas" : "Simpan Belum Lunas"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CartFlyAnimation flights={cartFlights} onComplete={finishProductFlight} />
      <TransactionSuccessFeedback feedback={transactionFeedback} onComplete={() => setTransactionFeedback(null)} />
      <CartItemNoteModal item={selectedCartItem} onSave={saveCartItemNote} />
      {canCreateProductions ? (
        <FormProduction
          isShowModal={isShowModal}
          isEdit={isEdit}
          closeModal={closeModal}
          formState={productionState}
          setFormState={setProductionState}
          addProduction={addProduction}
          canProcess={canCreateProductions}
        />
      ) : null}
      <VariantSelectionModal
        group={selectedProductGroup}
        onClose={() => setSelectedProductGroup(null)}
        onSelect={handleSelectVariant}
      />
      <VariantAvailabilityDrawer
        variant={unavailableCatalogProduct}
        onClose={() => setUnavailableCatalogProduct(null)}
      />
      <FormCustomer
        isShowModal={false}
        isEdit={false}
        closeModal={closeCustomerModal}
        formState={customerFormState}
        setFormState={setCustomerFormState}
        handleAdd={handleAddCustomer}
        handleUpdate={() => {}}
        cities={cities || []}
        modalId="modal-pos-customer"
        modalClassName="pos-customer-modal"
      />

      <AlertConfirmModal
        type="warning"
        title="Apakah anda yakin?"
        message="Transaksi akan disimpan sebagai draft dan dapat dilanjutkan kembali dari halaman Penjualan."
        confirmText="Ya, Simpan Draft"
        cancelText="Batal"
        idModal="confirm-draft-sale"
        onConfirm={handleSaveDraft}
      />

      <AlertConfirmModal
        type="warning"
        title="Apakah anda yakin?"
        message={`Pembayaran masih kurang ${formatIDR(formState?.due || 0)}. Transaksi akan tersimpan sebagai belum lunas/piutang.`}
        confirmText="Ya, Simpan"
        cancelText="Batal"
        idModal="confirm-unpaid-sale"
        onConfirm={handleConfirmUnpaidSale}
      />

      <AlertConfirmModal
        title="Simpan perubahan dan pembayaran?"
        message={`Pembayaran tambahan ${formatIDR(paymentPreviewAmount)} melalui ${PAYMENT_METHOD_LABELS[formState.payment_method] || "Tunai"}. ${formState.due > 0 ? `Sisa tagihan ${formatIDR(formState.due)} akan tetap Belum Lunas.` : "Transaksi akan menjadi Lunas."}${formState.change > 0 ? ` Kembalian ${formatIDR(formState.change)}.` : ""} Pastikan pembayaran sudah diterima.`}
        confirmText="Ya, Simpan & Bayar"
        cancelText="Batal"
        idModal="confirm-edit-payment"
        onConfirm={() => handleUpdateSale(true)}
      />
      <QRISModal
        total={paymentPreviewAmount}
        storeSetting={storeSetting}
        paymentNote={isEditingSale ? "QRIS sesuai nominal pembayaran tambahan. Setelah dana diterima, tutup QRIS lalu pilih Simpan & Bayar." : undefined}
      />
      <TransferAccountModal
        total={paymentPreviewAmount}
        paymentAccount={transferPaymentAccount}
        loading={isTransferAccountLoading}
      />
      {isCashierShiftEnabled ? (
        <>
          <div className="modal modal-blur fade" id="modal-open-shift" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Buka Shift Kasir</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Kas Awal</label>
                    <div className="input-group">
                      <span className="input-group-text bg-primary text-white">Rp</span>
                      <NumberInput
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        value={openingCash}
                        onChange={(e) => setOpeningCash(Number(e.target.value || 0))}
                        placeholder="0"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Catatan Pembuka</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={openingNote}
                      onChange={(e) => setOpeningNote(e.target.value)}
                      placeholder="Opsional, contoh: shift pagi"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ms-auto"
                    data-bs-dismiss="modal"
                    onClick={handleOpenShift}>
                    Buka Shift
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal modal-blur fade" id="modal-close-shift" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Tutup Shift Kasir</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                  <div className="row g-3 mb-3">
                    <div className="col-6">
                      <div className="small text-muted">Kas Awal</div>
                      <div className="fw-bold">{formatIDR(currentCashierShift?.opening_cash || 0)}</div>
                    </div>
                    <div className="col-6">
                      <div className="small text-muted">Kas Masuk</div>
                      <div className="fw-bold">{formatIDR(currentShiftSummary?.cash_sales_total || 0)}</div>
                    </div>
                    <div className="col-6">
                      <div className="small text-muted">Estimasi Kas</div>
                      <div className="fw-bold text-primary">{formatIDR(expectedClosingCash)}</div>
                    </div>
                    <div className="col-6">
                      <div className="small text-muted">Selisih</div>
                      <div className={`fw-bold ${closingDifference < 0 ? "text-danger" : "text-primary"}`}>
                        {formatIDR(closingDifference)}
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Kas Fisik Saat Ini</label>
                    <div className="input-group">
                      <span className="input-group-text bg-primary text-white">Rp</span>
                      <NumberInput
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        className="form-control"
                        value={closingCash}
                        onChange={(e) => setClosingCash(Number(e.target.value || 0))}
                        placeholder="0"
                      />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Catatan Penutup</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={closingNote}
                      onChange={(e) => setClosingNote(e.target.value)}
                      placeholder="Opsional, contoh: kas cocok / ada selisih"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-link link-secondary" data-bs-dismiss="modal">
                    Batal
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ms-auto"
                    data-bs-dismiss="modal"
                    onClick={handleCloseShift}>
                    Tutup Shift
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataProducts: state?.products?.datas,
  customers: state?.customers?.datas?.data || [],
  cities: state?.regions?.cities?.data || state?.regions?.cities?.datas?.data || [],
  products: state?.products?.datas?.data || [],
  materials: state?.materials?.datas?.data || [],
  sales: state?.sales?.datas?.data || [],
  storeSetting: state?.stores?.setting,
  isLoading: state?.sales?.loading,
  productLoading: state?.products?.loading,
  productGroups: state?.productGroups?.datas?.data || [],
  productGroupLoading: state?.productGroups?.loading,
  currentCashierShift: state?.cashierShifts?.current,
  cashierShiftLoading: state?.cashierShifts?.loading,
  userProfile: state?.auth?.login?.profile,
});

export default connect(mapStateToProps, {
  fetchProducts,
  fetchProductGroups,
  fetchMaterials,
  addSale,
  getSaleById,
  updateSale,
  fetchCustomers,
  addCustomer,
  fetchCities,
  addProduction,
  fetchCurrentCashierShift,
  openCashierShift,
  closeCashierShift,
  fetchPosPaymentAccount,
})(PosPage);
